import configRepository from '../repositories/ConfigRepository';
import axios from 'axios';
import Vue from 'vue';
// Import the EventBus
import { EventBus } from '../repositories/Eventbus';
import timeStore from '../repositories/TimeManager';
import logRepository from '../repositories/LogRepository';
import { ErrorStatus } from '../repositories/Constants';

// import { signalR } from '@aspnet/signalr';
const signalR = require("@microsoft/signalr");

var OrderRepository = function () {

  

    var _data = new Vue({

        data: {

            orders: [],

            units: [],

            showOrders: configRepository.showOrders,

            showReciepts: configRepository.showReciepts,

            showCollect: configRepository.showCollect,

            showBonChef: configRepository.showBonChef,

            collectUnitGroupIds: timeStore.collectUnitGroupIds,

            statusFilter: [],

            selectedTableNumber: '',

            timelineSettings: {
                /*
                * Gets or sets a value indicating wheter the orders are automatic planned or manual
                * **/
                //autoPlanUnits: true,
                /*
                * Gets or sets a value indicating wheter the timeline is paused or not
                * **/
                pause: false,

                /*
                * Gets or sets the amount of seconds the timeline is shifted
                * **/
                shiftSeconds: 0,

                /*
                 * Gets or sets the connection state
                 * **/
                connected: false,

                playSound: false
            },
        },

        computed: {

            visibleOrders: function () {

                console.log('visibleorders');

                var orders = this.$signalR.orders.sort(function (a, b) {
                    if (a.sortableStartDateString < b.sortableStartDateString) {
                        return -1;
                    } else {
                        return 0;
                    }
                })

                var _timeStamps = {};

                var filteredOrders = [];

                if (this.selectedTableNumber.length) {
                    filteredOrders = orders.filter(a => a.tableNumber == this.selectedTableNumber);
                    if (!filteredOrders.length) {
                        this.selectedTableNumber = '';
                        filteredOrders = orders;

                    }
                } else {
                    filteredOrders = orders;
                }

                // filter
                if (this.statusFilter.length > 0) {
                    filteredOrders = filteredOrders.filter(order => this.statusFilter.includes(order.status));
                }

                filteredOrders.forEach(order => {
                    order.showTimestamp = _timeStamps[order.intervalTimeStamp] == null;
                    if (_timeStamps[order.intervalTimeStamp] == null) {
                        _timeStamps[order.intervalTimeStamp] = 1;
                    }
                });

                return filteredOrders;
                
            },

            tableNumbers : function()  {
                return [...new Set(this.orders.filter(a => a.tableNumber.length).map(order => order.tableNumber))].sort((a, b) => a - b);
            }
        },
        methods: {

            setOrderStatus: function (order, status) {
                _invoke("ChangeOrderStatus", order.id, status);
            },

            setStartDate: function (order, date) {
                _invoke("ChangestartDate", order.id, date);
            },

            //setAutoPlanUnits: function (autoPlan) {
            //	signalRHub.invoke('setAutoPlanUnits', autoPlan);
            //},
            setPause: function (pause) {

                _invoke('SetPause2', pause);
            },

            deleteOrder: function (order) {
                _invoke('DeleteOrder', order.id);
            },

            addMinutes: function (minutes) {
                _invoke('AddMinutes', minutes);
            },

            setUnitState: function (unitGroupId, unitId, state) {
                _invoke('SetUnitState', unitGroupId, unitId, state);
            },

            getMoreOrdersReset: function () {

                _data.units.forEach(function (unitgroup) {
                    unitgroup.units.forEach(function (unit) {
                        while (unit.batches.length) {
                            var batch = unit.batches.pop();

                            while (batch.orders.length) {
                                batch.orders.pop();
                            }

                            while (batch.products.length) {
                                batch.products.pop();
                            }

                        }
                    });
                });

                while (_data.orders.length) {
                    _data.orders.pop();
                }

                // get the orders, even when the orders timeline is not visible, we use references to them in the batches
                _invoke("GetAllOrderModels").catch(function (err) { window.console.log(err) });
                _invoke("GetUnits", []).catch(function (err) { window.console.log(err) });

                var date = new Date();

                timeStore.setStartTime(new Date(date.getFullYear(), date.getMonth(), date.getDate() - 1, 22, 0, 0));
                timeStore.setEndTime(new Date(date.getFullYear(), date.getMonth(), date.getDate() + 1, 10, 0, 0));
                timeStore.setAutoScroll(true);

                timeStore.setHistorySearch(false);

            },

            getMoreOrders: function (visibleUnitGroups) {

                var filteredOrders = this.orders.filter((order) =>
                    order.batches.some((batch) =>
                        visibleUnitGroups.some((unitGroup) => unitGroup.id === batch.unitGroupId)
                    )
                );

                var dateTime = new Date();

                if (filteredOrders.length) {
                    var firstOrder = filteredOrders.sort(function (a, b) {
                        if (a.startDate < b.startDate) {
                            return -1;
                        } else {
                            return 0;
                        }
                    })[0];

                    dateTime = firstOrder.startDate;
                }

                const visibleUnits = visibleUnitGroups.flatMap((group) => group.units.map((unit) => unit.id));

                _searchOrders({ toDate: dateTime, amount: 5, unitsFilter: visibleUnits }, dateTime);

            },

            /**
             * Searches for 5 orders with the requested ordernummer
             * The orders are shown on the timeline, but not actualy planned
             * @param {any} searchText
             * @returns  a promise 
             */
            searchOrders: function (searchText) {
                return _searchOrders({ OrderNumber: searchText }, new Date());
            },

            /**
             * Searches for orders on the requested day, till the requested timestamp
             * The orders are shown on the timeline, but not actualy planned
             * @param {any} searchTo
             * @returns a promise 
             */
            searchDayTill: function (searchTo) {
                var date = new Date(searchTo);
                return _searchOrders({ loadDayTo: date }, new Date());
            },

            /**
             * Sets the selectedTableNumber
             * @param {Int} tableNumber
             */
            setTableNumber(tableNumber) {    
               
                this.selectedTableNumber = (tableNumber == this.selectedTableNumber) ? '' : tableNumber;
                // fire event
                EventBus.$emit('tablenumber-changed', _data.selectedTableNumber);
            }
        }
    });

    function _searchOrders(searchModel, dateTime) {
        return new Promise((resolve, reject) => {
            // get orders
            axios({
                method: 'POST',
                url: configRepository.endPointUrl + 'api/hub/GetOrders/',
                data: searchModel,
                withCredentials: true
            })
                .then(function (response) {
                    if (response.data.success) {
                        var newStartDate = dateTime;

                        var _orders = response.data.data.orders;
                        _orders.forEach(order => {
                            initOrder(order);

                            order.fromHistorySearch = true;

                            _data.orders.push(order);
                            if (order.startDate < newStartDate) {
                                newStartDate = order.startDate;
                            }
                        });

                        var _batches = response.data.data.batches;
                        _batches.forEach(batch => {
                            _data.units.forEach(function (unitgroup) {
                                if (unitgroup.id == batch.unitGroupId) {
                                    unitgroup.units.forEach(function (unit) {
                                        if (unit.id == batch.unitId) {
                                            batch.startTime = new Date(batch.startTime);
                                            batch.endTime = new Date(batch.endTime);
                                            relateBatchOrders(batch);

                                            if (!unit.batches.find(a => a.id == batch.id)) {
                                                unit.batches.push(batch);
                                            }
                                        }
                                    });
                                }
                            });
                        });

                        timeStore.setStartTime(new Date(newStartDate.getFullYear(), newStartDate.getMonth(), newStartDate.getDate() - 1, 22, 0, 0));
                        timeStore.setEndTime(new Date(newStartDate.getFullYear(), newStartDate.getMonth(), newStartDate.getDate() + 1, 10, 0, 0));
                        timeStore.setHistorySearch(true);
                        timeStore.setAutoScroll(false);

                        resolve(_orders); // Resolving with the fetched data for further handling
                    } else {
                        reject(new Error("Order fetch was unsuccessful")); // Rejecting if the success flag is false
                    }
                })
                .catch(function (err) {
                    logRepository.addLog("error fetching orders from server", ErrorStatus.Error);
                    logRepository.addLog(err, ErrorStatus.Error);

                    window.console.error('error fetching orders from server');
                    window.console.error(err);

                    reject(err); // Rejecting with the error for error handling in calling code
                });
        });
    }

    /** Invoke the hub functions
    **/
    function _invoke() {
        if (signalRHub.state == 'Connected') {
            return signalRHub.invoke.apply(signalRHub, arguments);
        } else {
            alert('de connectie is verbroken');
        }
    }

    // start the signalRhub connection
    var signalRHub = new signalR
        .HubConnectionBuilder()
        .withAutomaticReconnect([0, 2000, 2000, 2000])
        //.withAutomaticReconnect([0, 2000, 10000, 30000]) yields the default behavior
        .withUrl(configRepository.endPointUrl + 'unitHub')
        .build();


    window.addEventListener("offline", function () {
        _data.timelineSettings.offline = true;
        _data.timelineSettings.connected = false;
        logRepository.addLog("Status turned to offline", ErrorStatus.Warning);
    }, false);

    window.addEventListener("online", function () {
        if (_data.timelineSettings.offline) {
            logRepository.addLog("Status turned to online,  reloading page to catch up missing orders", ErrorStatus.Warning);
            // catch up with missing orders
            window.location.reload(true);
        } else {
            logRepository.addLog("Status turned to online", ErrorStatus.Warning);
        }
    }, false);

    var _reloading = false;
    window.addEventListener('beforeunload', function () {
        _reloading = true;
    });

    // in case the server is lost
    signalRHub.onreconnecting(() => {

        if (!_reloading) {
            logRepository.addLog("signalRHub disconnected, attempt to reconnect", ErrorStatus.Warning);
        }

        _data.timelineSettings.connected = false;
    });

    // the server is up again
    signalRHub.onreconnected(() => {

        logRepository.addLog("signalRHub reconnected", ErrorStatus.Warning);

        if (!_data.timelineSettings.connected) {

            logRepository.addLog("signalRHub reconnected, reloading page to catch up missing orders", ErrorStatus.Warning);
            _data.timelineSettings.connected = true;
            // catch up with missing orders
            window.location.reload(true);
        }
    });
    // the server is lost and tried to reconnect acording the above settings (.withAutomaticReconnect([0, 2000, 10000, 30000]))
    signalRHub.onclose(() => {
        // redirect to login page.
        // window.location = '/#login';
        logRepository.addLog("signalRHub connection closed, to many retries, reload page.", ErrorStatus.Warning);

        _data.timelineSettings.connected = false;
        window.location.reload(true);
    });

    axios({
        method: 'GET',
        url: configRepository.endPointUrl + 'api/terminal/isAuthenticated',
        withCredentials: true
    }).then(function (response) {

        _data.timelineSettings.connected = true;

        if (response.data.success) {

            configRepository.user.name = response.data.username;
            configRepository.user.isAdmin = response.data.isAdmin;

            logRepository.addLog('Authenticated: ' + response.data.username + ' starting connection', ErrorStatus.Message);

            // authenticated, start connection
            window.console.log('Authenticated: ' + response.data.username + ' starting connection');

            var config = configRepository.getConfig();

            if (config.playSound) {
                _data.timelineSettings.playSound = true;


                // try if sound can be played.
                // https://developer.chrome.com/blog/autoplay/        
                const neworderAudio = new Audio(config.endPointUrl + 'audio/silent.wav');
                try {
                    neworderAudio.play().then(function () { }, function () {
                        _data.timelineSettings.playSound = false;
                    })
                    //ok
                } catch (e) {
                    _data.timelineSettings.playSound = false;
                }
            }

            start();
        } else {
            // redirect to login page.
            window.location = '/#login';
        }
    }).catch(function () {
        _data.timelineSettings.connected = false;
        window.location = '/#configReconnect';
    });

    async function start() {

        // https://www.dotnetcurry.com/aspnet-core/1511/authentication-aspnetcore-signalr-vuejs
        signalRHub.start().then(function () {

            _data.timelineSettings.connected = true;

            // get the orders, even when the orders timeline is not visible, we use references to them in the batches
            _invoke("GetAllOrderModels").catch(function (err) { window.console.log(err) });
            _invoke("GetUnits", []).catch(function (err) { window.console.log(err) });
            _invoke("GetTimelineSettings").catch(function (err) { window.console.log(err) });


        }).catch(function (err) {

            _data.timelineSettings.connected = false;

            logRepository.addLog('SignalR error', ErrorStatus.Error);
            logRepository.addLog(err, ErrorStatus.Error);

            setTimeout(() => start(), 5000);

        });
    }


    /**
     * Called as a response of getAllOrderModels which is called on startup
     */
    signalRHub.on("broadcastAllOrderModels", function (orders) {
        try {

            for (var v in orders) {
                initOrder(orders[v]);
                _data.orders.push(orders[v]);
            }

        } catch (e) {
            logRepository.addLog("broadcastAllOrderModels: " + e.message, ErrorStatus.Error);
        }
    });

    /**
     * Called when properties of an order have been changed
     */
    signalRHub.on("broadcastOrderChanged", function (order, properties) {
        try {
            if (properties.indexOf('showOnTimeLine') >= 0) {
                if (!order.showOnTimeLine) {
                    var index = _data.orders.findIndex(function (a) { return a.id == order.id });

                    if (index >= 0) {
                        var foundOrder = _data.orders[index];

                        try {
                            while (foundOrder.batches && foundOrder.batches.length) {
                                //var batch = foundOrder.batches[foundOrder.batches.length - 1];
                                var batch = foundOrder.batches.splice(foundOrder.batches.length - 1, 1);
                                if (batch.length) {
                                    removeBatch(batch[0]);
                                }
                            }
                        } catch (e) {
                            logRepository.addLog('broadcastOrderChanged error: ' + e.message, ErrorStatus.Error);
                        }

                        // console.log('splice order :' + order.id);

                        _data.orders.splice(index, 1);

                        foundOrder = null;
                    }
                }

                return;
            }

            for (var v in _data.orders) {
                if (_data.orders[v].id == order.id) {

                    for (var prop in properties) {
                        let propName = properties[prop];
                        switch (propName) {
                            case 'startDate':
                            case 'createDate':
                            case 'calculatedReadyDate':
                            case 'calculatedShippedDate':
                            case 'desiredReadyDate':
                            case 'intervalTimeStamp':
                                _data.orders[v][propName] = new Date(order[propName]);
                                break;
                            case 'batches':
                                // ignore
                                break;
                            default:
                                _data.orders[v][propName] = order[propName];
                        }
                    }
                    break;
                }
            }

        } catch (e) {
            logRepository.addLog("broadcastOrderChanged: " + e.message, ErrorStatus.Error);
        }
    });

    /**
     * Called when an order is added
     */
    signalRHub.on("broadcastaddOrder", function (order) {

        window.console.log('Order recieved' + order.orderNr);

        try {
            // window.console.log("addOrder recieved" + order.orderNr);
            initOrder(order);
            _data.orders.push(order);

            if (_data.timelineSettings.playSound) {
                var config = configRepository.getConfig();
                var audio = configRepository.newOrderAudio;

                const neworderAudio = new Audio(config.endPointUrl + audio);
                neworderAudio.play();
            }

        } catch (e) {
            logRepository.addLog("broadcastaddOrder: " + e.message, ErrorStatus.Error);
        }
    });

    function initOrder(order) {
        order.startDate = new Date(order.startDate);
        order.createDate = new Date(order.createDate);
        order.intervalTimeStamp = new Date(order.intervalTimeStamp);
        order.showTimestamp = false;
        order.calculatedReadyDate = new Date(order.calculatedReadyDate);
        if (order.desiredReadyDate) {
            order.desiredReadyDate = new Date(order.desiredReadyDate);
        }
        if (order.calculatedShippedDate) {
            order.calculatedShippedDate = new Date(order.calculatedShippedDate);
        }
        order.batches = [];
        order.products.forEach(function (product) {
            product.batches = product.batches || []
        });

        timeStore.setOrderToFuture(order);
    }

    /**
    * Called when properties of a batch have been changed
    */
    signalRHub.on("broadCastEventQue", function (eventque) {
        // called when the event que on the server is flused.
        eventque.forEach(function (event) {
            window.console.log('broadCastEventQue' + event.command);

            signalRHub.invokeClientMethod({ target: event.command, arguments: [event.model, event.propertiesChanged] })
        });
    });

    /**
     * Called when properties of a batch have been changed
     */
    signalRHub.on("broadcastBatchChanged", function (changedBatch, properties) {

        try {
            _data.units.forEach(function (unitgroup) {
                if (unitgroup.id == changedBatch.unitGroupId) {
                    unitgroup.units.forEach(function (unit) {
                        if (unit.id == changedBatch.unitId) {
                            unit.batches.forEach(function (batch) {

                                let doRelate = false;
                                let removedOrderIds = [];
                                if (batch.id == changedBatch.id) {
                                    for (var prop in properties) {
                                        let propKey = properties[prop];
                                        switch (propKey) {
                                            case 'startTime':
                                            case 'endTime':
                                                batch[propKey] = new Date(changedBatch[propKey]);
                                                break;
                                            case 'products':
                                                batch.products = changedBatch.products;
                                                doRelate = true;
                                                break;
                                            case 'orders':
                                                // the real order match is done in relatebatchorders
                                                doRelate = true;
                                                removedOrderIds = batch.orderIds.filter(id => !changedBatch.orderIds.includes(id));
                                                batch.orderIds = changedBatch.orderIds;
                                                break;
                                            default:
                                                batch[propKey] = changedBatch[propKey];
                                        }
                                    }
                                }

                                if (doRelate) {
                                    relateBatchOrders(batch, removedOrderIds);
                                }

                            });
                        }
                    });
                }
            });
        } catch (e) {
            logRepository.addLog("broadcastBatchChanged: " + e.message, ErrorStatus.Error);
        }

        try {
            // fire event
            EventBus.$emit('batches-changed', [changedBatch]);

            if (properties.indexOf('status') >= 0 || properties.indexOf('bonchef') >= 0) {
                EventBus.$emit('batch-status-changed', [changedBatch]);
            }

        } catch (e) {
            logRepository.addLog("broadcastBatchChanged - batches-changed: " + e.message, ErrorStatus.Error);
        }
    });

    /**
     * Called when a batch is added
     */
    signalRHub.on("broadcastBatchAdded", function (addedBatch) {

        try {
            _data.units.forEach(function (unitgroup) {
                if (unitgroup.id == addedBatch.unitGroupId) {
                    unitgroup.units.forEach(function (unit) {
                        if (unit.id == addedBatch.unitId) {

                            addedBatch.startTime = new Date(addedBatch.startTime);
                            addedBatch.endTime = new Date(addedBatch.endTime);
                            addedBatch.scrollWidth = 300;

                            if (!unit.batches.find(a => a.id == addedBatch.id)) {
                                relateBatchOrders(addedBatch);
                                unit.batches.push(addedBatch);
                            }

                        }
                    });
                }
            });
        } catch (e) {
            logRepository.addLog("broadcastBatchAdded: " + e.message, ErrorStatus.Error);
        }

        try {
            // fire event
            EventBus.$emit('batches-changed');
        } catch (e) {
            logRepository.addLog("broadcastBatchAdded - batches-changed: " + e.message, ErrorStatus.Error);
        }

    });


    /**
     * Called when a batch is removed from the timeline
     */
    signalRHub.on("broadcastBatchRemoved", function (batch) {
        try {
            removeBatch(batch);
        } catch (e) {
            logRepository.addLog("broadcastBatchRemoved: " + e.message, ErrorStatus.Error);
        }

        try {
            // fire event
            EventBus.$emit('batches-changed');
        } catch (e) {
            logRepository.addLog("broadcastBatchRemoved - batches-changed: " + e.message, ErrorStatus.Error);
        }
    });


    function removeBatch(batch) {
        var batchRef = null;

        _data.units.some(function (unitgroup) {
            if (unitgroup.id == batch.unitGroupId) {
                unitgroup.units.some(function (unit) {
                    if (unit.id == batch.unitId) {
                        var index = unit.batches.findIndex(function (a) {
                            if (a.id === batch.id) {
                                return true;
                            }
                            return false;
                        });

                        if (index >= 0) {

                            batchRef = unit.batches.splice(index, 1)[0];
                        }
                        return true;
                    }
                });
                return true;
            }
        });


        function removebatchFromProducts(products, batch) {
            products.forEach(function (orderProduct) {

                if (orderProduct != null && (orderProduct.batches)) {
                    let orderIndex = orderProduct.batches.findIndex(a => a.id == batch.id);
                    if (orderIndex >= 0)
                        orderProduct.batches.splice(orderIndex, 1);
                }

                if (orderProduct.children && orderProduct.children.length) {
                    removebatchFromProducts(orderProduct.children, batch);
                }

            })

        }

        if (batchRef) {
            // find orders of this batch, remove this batch from the order
            batchRef.orders.forEach(function (order) {
                // remove the batches from the products (hiearchic)
                removebatchFromProducts(order.products, batch);

                // find the batch and remove it from the orer
                var batchIndex = order.batches.findIndex(function (c) { return c.id == batch.id });
                if (batchIndex >= 0)
                    order.batches.splice(batchIndex, 1);
            });
        } else {
            window.console.log('batch not found :' + batch);
        }

        batchRef = null;
    }


    function relateBatchOrders(batch, removedOrderIds) {

        if (!batch.products.length) {
            return;
        }
        var _batchOrders = [];

        // find orders of this batch, related them by id.
        batch.orderIds.forEach(function (a) {
            var order = _data.orders.find(function (b) { return b.id == a; });
            if (order != null) {

                _batchOrders.push(order);

                if (!order.batches.find(function (c) { return c.id == batch.id })) {
                    order.batches.push(batch);
                }
            }
        });

        // the batch original had multyple orders, when a split occurs, the order is removed from the batch on the server.
        // execute this removal also on the client
        if (removedOrderIds && removedOrderIds.length) {
            removedOrderIds.forEach(function (a) {
                var order = _data.orders.find(function (b) { return b.id == a; });
                if (order != null) {

                    let orderBatchIndex = order.batches.indexOf(batch);
                    if (orderBatchIndex >= 0) {
                        order.batches.splice(orderBatchIndex, 1);
                    }

                    order.products.forEach(product => {
                        let productBatchIndex = product.batches.indexOf(batch);
                        if (productBatchIndex >= 0) {
                            product.batches.splice(productBatchIndex, 1);
                        }
                    })

                }
            });
        }


        // find the products of this batch, relate matching orders by id.
        batch.products.forEach(function (batchProduct) {

            batchProduct.orders = [];

            // loop through the order('s) of this batch
            if (batchProduct.orderIds) {
                batchProduct.orderIds.forEach(function (orderId) {

                    var order = _batchOrders.find(function (b) { return b.id == orderId; });

                    if (order != null) {

                        batchProduct.orders.push(order);

                        // add the batch to the order product(s).
                        try {

                            // find the related product in the order.
                            // batch product can be grouped from multiple productid's in the same order.
                            // to resolve this, the original productids are available in the batch order
                            for (let productKey in order.products) {

                                let orderProduct = null;
                                let op = order.products[productKey];
                                if (op.isDishGroupholder) {
                                    orderProduct = op.children.find(function (op2) { return op2.id === batchProduct.id || batchProduct.orderProductIds.some(a => a === op2.id); });
                                } else {
                                    if (op.id === batchProduct.id || batchProduct.orderProductIds.some(a => a === op.id)) {
                                        orderProduct = op;
                                    }
                                }

                                if (orderProduct) {
                                    orderProduct.batches = orderProduct.batches || [];
                                    if (!orderProduct.batches.find(a => a.id == batch.id)) {
                                        orderProduct.batches.push(batch);
                                    }
                                    if (batchProduct.orderProductIds.length == 1) {
                                        // only one relation, no need to loop any further
                                        break;
                                    }
                                }
                            }
                        } catch (e) {
                            window.console.log(e);
                        }
                    }
                });
            }
        });

        batch.orders = _batchOrders;
    }

    signalRHub.on("broadcastAllUnits", function (unitGroups) {
        //   var startdate = new Date();
        // console.log('start relate all units for ' + _data.orders.length + ' orders'  + startdate);

        try {
            // empty current units
            while (_data.units.length) {
                _data.units.pop();
            }

            _data.orders.forEach(function (a) {
                a.batches = [];
                a.products.forEach(function (b) { b.batches = [] });
            });

            var config = configRepository.getConfig();

            for (let v in unitGroups) {

                let unitGroup = unitGroups[v];

                if (config.unitGroupIds.indexOf(unitGroups[v].id) >= 0) {
                    unitGroup.isVisible = true;
                }
                else {
                    unitGroup.isVisible = false;
                }

                _data.units.push(unitGroup);

                for (var b in unitGroup.units) {
                    let unit = unitGroup.units[b];

                    //unit.batches = unit.batches.filter(function (batch) {
                    //	return batch.orderIds.length;
                    //});

                    for (let c in unit.batches) {
                        let batch = unit.batches[c];
                        batch.startTime = new Date(batch.startTime);
                        batch.endTime = new Date(batch.endTime);
                        batch.scrollWidth = 300;
                        try {
                            relateBatchOrders(batch);
                        } catch (e) {
                            window.console.log(e);
                        }
                    }
                }
            }
        } catch (e) {
            logRepository.addLog("broadcastAllUnits: " + e.message, ErrorStatus.Error);
        }

        try {
            // fire event
            EventBus.$emit('batches-loaded');
        } catch (e) {
            logRepository.addLog("broadcastAllUnits - batches-loaded: " + e.message, ErrorStatus.Error);
        }

        // fire event
        EventBus.$emit('units-loaded');

        // console.log('end relate all units' + new Date() + ' took: ' + (new Date().getTime() - startdate.getTime() ) + 'ms');

    });

    signalRHub.on("broadcastTimelineSettings", function (settings) {
        //_data.timelineSettings.autoPlanUnits = settings.autoPlanUnits;
        _data.timelineSettings.pause = settings.pause;
        _data.timelineSettings.shiftSeconds = settings.shiftSeconds;
    });

    /*
     Handle server exceptions
     */
    signalRHub.on("broadcastException", function (ex) {
        window.console.log('The server threw an exeption');
        window.console.log(ex);
        logRepository.addLog('The server threw an exeption' + ex, ErrorStatus.Error);
    });

    /*
     * Handle server refresh 
     */
    signalRHub.on("clientRefresh", function () {
        window.location.reload(true);
    });


    /*
     * Handle server refresh 
     */
    signalRHub.on("warmingTraysChanged", function () {
        window.console.log('Warming tray changed event');
        EventBus.$emit('warmingtrays-changed');
    });

    return _data;

}()

export { OrderRepository as default };